import {Component, Input} from '@angular/core';

@Component ({
	selector: 'expand-collapse-buttons',
	templateUrl: './expand-collapse-buttons.component.html',
	styleUrls: ['./expand-collapse-buttons.component.css']
})
export class ExpandCollapseButtonsComponent {

	// Properties
	@Input() expandEmitter;

	// Class Functions
	constructor () {}

	// Events

	// Methods
	expandAll(expand: boolean) {
		if (this.expandEmitter != null) {
			this.expandEmitter.emit (expand);
		}
	}
}
